import "react-app-polyfill/ie11"; /** Support IE11 */
import "react-app-polyfill/stable"; /** Support IE11 */
import { ModalSession } from "../components/ModalSession";
import { getCookie } from "../libs/http";

let logoutTimeout = null;
let isRequesting = false;
let warningTimer;

const headers = {
  Accept: "application/json",
  "X-CSRF-Token": getCookie("_enhanced_portal_session"),
};

const options = {
  method: "POST",
  credentials: "include",
  headers,
};

export const checkForSessionTimeout = () => {
  if (isRequesting) return;

  isRequesting = true;
  fetch("/api/v1/session_timeouts/remaining_time", options)
    .then((res) => res.json())
    .catch((error) => {
      throw error;
    })
    .then(({ time_left: timeInSeconds }) => {
      logoutTimeout = setTimeout(() => {
        fetch("/api/v1/session_timeouts/remaining_time", options)
          .then((res) => res.json())
          .catch((error) => {
            throw error;
          })
          .then((res) => {
            isRequesting = false;
            if (res.time_left < 70) ModalSession(res.time_left);
            else checkForSessionTimeout();
          });
      }, timeInSeconds * 1000 - 70000);
    });
};

export const shortSessionTimer = () => {
  const sessionDuration = 15 * 60 * 1000;
  const warningTime = sessionDuration - 60 * 1000;
  const modalTimer = sessionDuration - warningTime;

  warningTimer = setTimeout(() => {
    ModalSession(modalTimer / 1000, 15, true);
  }, warningTime);
}

export const resetSessionTimer = () => {
  clearTimeout(warningTimer);
  shortSessionTimer();
}
